import gql from 'graphql-tag';
import { ACCOUNT_CONTACT_FRAGMENT } from './fragment';

export const ACCOUNT_CONTACT = gql`
  ${ACCOUNT_CONTACT_FRAGMENT}
  query AccountContact($input: AccountContactInput!) {
    accountQuery {
      contact(input: $input) {
        success
        error
        entity {
          ...AccountContactFields
        }
      }
    }
  }
`;
